export default "__VITE_ASSET__c8083bd0__"